import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "editSensor" }
const _hoisted_2 = { class: "editSensor__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "editSensor__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Input = _resolveComponent("Input")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showModalEditSensor)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeModal')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('editSensor')), 1),
                _createElementVNode("img", {
                  class: "editSensor__header-img",
                  src: _imports_0,
                  alt: "Close Modal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
                })
              ]),
              _createVNode(_component_FormKit, {
                id: "editSensor-form",
                modelValue: _ctx.formData,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData) = $event)),
                type: "form",
                actions: false,
                onSubmit: _ctx.submitHandler
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoSensor, (el, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "infoSensor"
                    }, [
                      _createVNode(_component_Input, {
                        type: el.type,
                        name: el.name,
                        label: _ctx.$t(el.label),
                        disabled: el.name === 'sn' || el.name === 'id'
                      }, null, 8, ["type", "name", "label", "disabled"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onSubmit"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Button, {
                  variant: "filled",
                  title: _ctx.$t('save'),
                  onClick: _ctx.editSensor
                }, null, 8, ["title", "onClick"]),
                _createVNode(_component_Button, {
                  variant: "bordered",
                  title: _ctx.$t('cancel'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeModal')))
                }, null, 8, ["title"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}